import { Route, Routes, useNavigate } from "react-router";
import Plano from "./plano";
import Espacios from "./espacios";
import { AppBar, Box, Button, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from "react";
import ReservaUbicacionDialog from "../components/reservarOcupacion";
import ScanDNIDialog from "../components/scanDNIDialog";
import BusquedaDialog from "../components/busquedaDialog";
import { PersonSearch, Refresh } from '@mui/icons-material';
import Login from "./login";
import LoginDialog from "../components/loginDialog";
import { doLogin, doLogout } from "../lib/auth";
import APIManager from "../lib/apiManager";
import Swal from "sweetalert2";

export default function Main({ usuario, espacios, actualizarEspacios, setLoadingOpen, setUsuario }) {
  let navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [conBack, setConBack] = useState(false);

  const [espacio, setEspacio] = useState(null);
  const [ubicacion, setUbicacion] = useState(null);
  const [visitante, setVisitante] = useState(null);
  const [reservaOpen, setReservaOpen] = useState(false);

  const [scanDNIDialogOpen, setScanDNIDialogOpen] = useState(false);
  const [busquedaDialogOpen, setBusquedaDialogOpen] = useState(false);

  const changeTitle = (newTitle) => {
    setTitle(newTitle);
  }

  const changeConBack = (llevaBack) => {
    setConBack(llevaBack);
  }

  const guardarConfirmacion = (info, callback) => {
    // Actualizamos la ubicacion (update local)
    if (!!ubicacion.visitante) {
      // Devolucion
      ubicacion.visitante = null;
      ubicacion.status = "free";
    } else {
      // Reserva
      ubicacion.visitante = { nombre: info.nombre, documento: info.documento };
      ubicacion.status = "occupied";
    }
    APIManager.sendRequest('post', 'parking', 'guardarReserva', {reserva: {posicionID: ubicacion.id, reservaID: ubicacion.reservaID, visitante: ubicacion.visitante}}, (response) => {
      if (response.success) {
        // Se guardo con exito
        callback();
      } else {
        if (!response.data.reservaID) {
          Swal.fire({
            title: 'Error al grabar',
            text: !!response.data?.posicionReservada ? 'Posición ya reservada' : 'No se pudo grabar la reserva',
            icon: 'error',
            confirmButtonColor: '#08996B',
            confirmButtonText: 'ACEPTAR',
            allowOutsideClick: false,
          })
        }
      }
    })
  }

  const handleSelectSpace = (selectedId) => {
    setEspacio(espacios.find(item => item.id == selectedId));
    // redirect('/plano:' + selectedId);
    navigate('/plano/' + selectedId);
  }

  const handleSelectedSlots = (selectedIds) => {
    APIManager.sendRequest('post', 'parking', 'verificarDisponible', { posicionID: selectedIds[0] }, (response) => {
      if (response.success) {
        if (!response.data || response.data?.idusuario == usuario.id) {
          setUbicacion(Object.values(espacio.planos[0].posiciones).find(slot => slot.id == selectedIds[0] ?? null));
        } else {
          actualizarEspacios();
        }
      }
    })
  }

  const handleReservaConfirm = (info) => {
    guardarConfirmacion(info, () => {
      actualizarEspacios();
      handleReservaDialogClose();
    });
  }

  const handleReservaDialogClose = () => {
    setReservaOpen(false);
    APIManager.sendRequest('post', 'parking', 'liberarPosicion', { posicionID: ubicacion.id }, (response) => {
      if (response.success) {
        actualizarEspacios();
      }
    });
    setUbicacion(null);
  }

  const handleScanDNI = () => {
    setScanDNIDialogOpen(true);
  }

  const handleScanConfirm = () => {
    handleScanClose();
  }

  const handleScanClose = () => {
    setScanDNIDialogOpen(false);
  }

  const handleBack = () => {
    navigate(-1);
  }

  const handleAbrirBusqueda = () => {
    setBusquedaDialogOpen(true);
  }

  const handleBusquedaConfirm = (item) => {
    handleBusquedaCancel();
    setUbicacion(espacio.slots.find(slot => slot.id == item.ubicacion.id));
  }

  const handleBusquedaCancel = () => {
    setBusquedaDialogOpen(false);
  }

  // useEffect(() => {
  //   if (!usuario) {
  //     navigate('/login');
  //   } else {
  //     if (window.location.pathname.includes('login')) {
  //       navigate('/');
  //     }
  //   }
  // }, [usuario]);

  const handleLoginConfirm = (userData) => {
    doLogin(userData, setUsuario);
  }

  useEffect(() => {
    if (window.sistema) {
      window.sistema.espacio = espacio
     };
    if (!espacio && window.location.pathname.includes('plano')) {
      navigate('/');
    }
  }, [espacio]);

  useEffect(() => {
    if (window.sistema) {
      window.sistema.ubicacion = ubicacion;
     };
    if (!!ubicacion) {
      APIManager.sendRequest('post', 'parking', 'tomarPosicion', { posicionID: ubicacion.id });
      setVisitante(ubicacion.visitante ?? null);
      setReservaOpen(true);
    }
  }, [ubicacion]);

  useEffect(() => {
    if (!!espacio) {
      setEspacio(espacios.find(item => item.id == espacio.id));
    }
  }, [espacios]);

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Typography variant="h6">{title}</Typography>
          <Stack direction="row" spacing={2}>
            {!!window.location.pathname.includes('plano') &&
              <Button color="warning" variant="outlined" startIcon={<PersonSearch />} onClick={handleAbrirBusqueda}>Buscar</Button>
            }
            {!!conBack ?
              <IconButton aria-label="logout" onClick={handleBack}>
                <ArrowBack />
              </IconButton>
              : !!usuario &&
              <IconButton aria-label="logout" onClick={()=>doLogout(setUsuario)}>
                <Logout />
              </IconButton>
            }
            <IconButton aria-label="refresh" onClick={()=>actualizarEspacios()}>
              <Refresh />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>
      {!!busquedaDialogOpen && <BusquedaDialog open={busquedaDialogOpen} espacio={espacio} onCancel={handleBusquedaCancel} onConfirm={handleBusquedaConfirm}/>}
      {!!reservaOpen && <ReservaUbicacionDialog open={reservaOpen} devolucion={!!visitante} title={!!visitante ? 'Devolución de carrito' : 'Ingreso de carrito'} slotId={ubicacion?.id} slotLabel={ubicacion?.label} visitante={visitante} editable={!visitante} onCancel={handleReservaDialogClose} onConfirm={handleReservaConfirm} onScanDNI={handleScanDNI} />}
      {!usuario && <LoginDialog open={true} onConfirm={handleLoginConfirm} setLoadingOpen={setLoadingOpen} setUsuario={setUsuario}></LoginDialog>}
      <ScanDNIDialog open={scanDNIDialogOpen} onCancel={handleScanClose} onConfirm={handleScanConfirm} />
      <Routes>
        {/* <Route path='login' element={<Login setLoadingOpen={setLoadingOpen} setUsuario={setUsuario}  />} /> */}
        <Route index element={<Espacios espacios={espacios} changeConBack={changeConBack} changeTitle={changeTitle} onSelectSpace={handleSelectSpace} actualizarEspacios={actualizarEspacios} />}></Route>
        <Route path='/plano/:id' element={<Plano espacio={espacio} selected={[ubicacion?.id]} changeConBack={changeConBack} changeTitle={changeTitle} onChangeSelected={handleSelectedSlots} onBuscar={handleAbrirBusqueda} />}></Route>
      </Routes>
    </Box>
    );

  }
